// extracted by mini-css-extract-plugin
export default {"container":"TableHeader__container-d7SQT","row":"TableHeader__row-xlhOq","sticky":"TableHeader__sticky-v17Dx"};